import './css/App.css';
import ProtectedRoute from "./components/ProtectedRoute";
import HomePage from "./HomePage";
import HomePageOrgInfo from"./HomePageOrgInfo";
import Dashboard from "./Dashboard";
import DashboardHome from "./DashboardHome";
import LoginOrganiser from "./LoginOrganiser";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import EventHome from './EventHome';
import EventCreationStep from './EventCreationStep';
import EventDetails from './EventDetails';
import EventUpdateDetails from './EventUpdateDetails';
import TicketPurchase from './TicketPurchase';
import TicketCheckout from './TicketCheckout';
import PrivatePurchase from './PrivatePurchase';
import PrivateCheckout from './PrivateCheckout';
import TicketConfirmation from './TicketConfirmation';
import PrivateConfirmation from './PrivateConfirmation';
import CompanySettingsForm from './CompanySettingsForm';
import Help from'./Help';
import HomePageHelp from './HomePageHelp';
import PrivacyPolicy from './PrivacyPolicy';
import TermsAndConditions from './TermsAndConditions';
import Invoice from "./Invoice";
import AdminHome from "./AdminHome";

function App() {
  return (
	<Router>
	  <Routes>
	    <Route path="/" element={<HomePage />} />
		<Route path="/orginfo" element={<HomePageOrgInfo/>} />
		<Route path="/homepagehelp" element={<HomePageHelp/>} />
		<Route path="/login" element={<LoginOrganiser />} />
		<Route path="/privacy" element={<PrivacyPolicy/>} />
		<Route path="/toc" element={<TermsAndConditions/>} />
		
		<Route path="/dashboard" element={ <ProtectedRoute> <Dashboard /> </ProtectedRoute>} >
			<Route index element={<DashboardHome />} />
			<Route path="events" element={<EventHome />} />
			<Route path="events/new" element={<EventCreationStep />} />
			<Route path="events/:id" element={<EventDetails />} />
			<Route path="events/update" element={<EventUpdateDetails />} />
			<Route path="settings" element={<CompanySettingsForm/>} />
			<Route path="invoice" element={<Invoice/>} />
			<Route path="help" element={<Help/>} />
			<Route path="admin" element={<AdminHome/>} />
		</Route>
		
		<Route path="/buy/:eventid" element={<TicketPurchase />} />
		<Route path="/buy/ticketcheckout/:eventid" element={<TicketCheckout />} />
		<Route path="/buy/ticketconfirmation/:eventid" element={<TicketConfirmation />} />
		
		<Route path="/pay/:eventid" element={<PrivatePurchase />} />
		<Route path="/pay/privatecheckout/:eventid" element={<PrivateCheckout />} />
		<Route path="/pay/privateconfirmation/:eventid" element={<PrivateConfirmation />} />
		
	  </Routes>
	</Router>

  );
}

export default App;
